import { createRefundCheck } from '@/api/tablet';
import { useMutation } from 'react-query';

type CreateRefundVariables = {
  totalAmount: number;
  refundAmount: number;
  finalAmount: number;
  isDirectPayment: boolean;
  defaultStatus?: string;
};

const useCreateRefundCheck = (userId: string, tabletId: string) => {
  return useMutation({
    mutationFn: ({
      totalAmount,
      refundAmount,
      finalAmount,
      isDirectPayment,
      defaultStatus,
    }: CreateRefundVariables) =>
      createRefundCheck(
        userId,
        tabletId,
        totalAmount,
        refundAmount,
        finalAmount,
        isDirectPayment,
        defaultStatus,
      ),
  });
};

export default useCreateRefundCheck;
